import {REDUCER_NAME} from './const'

export const selectOwnState = (state) => {
    return state[REDUCER_NAME]
}

export const selectLowNpsReasonList = (state) => {
    return selectOwnState(state).lowNpsReasonList
}

export const selectScore = (state) => {
    return selectOwnState(state).feedbackScore
}

export const selectCreated = (state) => {
    return selectOwnState(state).feedbackCreated
}

export const selectFeedbackId = (state) => {
    return selectOwnState(state).feedbackId
}



// WEBPACK FOOTER //
// ./src/modules/feedback/state/selector.js